export default __webpack_public_path__ + "static/media/hero-video-mobile-es.ca4b71fc.webm";